import React, { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import AppNavigator from './AppNavigator';
import AuthNavigator from './AuthNavigator';
import ServiceUnavailableScreen from '../screens/ServiceUnavailableScreen';
import { ActivityIndicator, View, StyleSheet } from 'react-native';

const RootNavigator = () => {
  const { isAuthenticated, loading, user } = useContext(AuthContext);

  if (loading) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color="#0d6efd" />
      </View>
    );
  }

  if (isAuthenticated) {
    const isClusterDisabled = user?.participant?.fcp?.cluster?.status === 'disabled';
    
    if (isClusterDisabled && user?.role !== 'admin') {
      return <ServiceUnavailableScreen />;
    }
    
    return <AppNavigator />;
  }

  return <AuthNavigator />;
};

const styles = StyleSheet.create({
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f8f9fa',
  },
});

export default RootNavigator;
